import { userRoutes } from 'modules/user/routes/constants';

export const profileRoutes = {
  root: `${userRoutes.root}/profile`,
};
